import React, { useState, useEffect} from "react";
import { Row, Col, Card, Button, Tag, Modal, Collapse} from "antd";


let release_date = "07/07/2025";
const LOCAL_STORAGE_KEY = "whats_new_seen_date";

const whatsNewFeatures = [
  {
    image: "https://public-assets.instantdm.com/product-gifs/instantdm-followup-demo-0707-2025.png",
    title: "Follow up Automation",
    description: "If your followers are not responding or not opened link, you can now follow up with them automatically. Boost your engagement with our new follow-up automation feature.",
    buttonText: "Try Now",
    // buttonLink: "/flow",
    tag: { color: "blue", text: "🔌 Flow Editor" }
  },
  {
    image: "https://public-assets.instantdm.com/product-gifs/instantdm-delay-automation-0707-2025-2.png",
    title: "Delay time increased",
    description: "We have increased the delay time for flow automation to 24 hours, so you can now automate your flows with more flexibility.",
    buttonText: "Learn More",
    // buttonLink: "/docs/global-automation",
    tag: { color: "blue", text: "🔌 Flow Editor" }
  },
  {
    image: "https://public-assets.instantdm.com/product-gifs/instantdm-delete-automation-0707-2025-2.png",
    title: "Delete Flows",
    description: "The most requested feature is here! You can now delete your flows, so you can keep your flow list clean and organized.",
    buttonText: "Learn More",
    // buttonLink: "/docs/global-automation",
    tag: { color: "red", text: "🔥 Most Requested" }
  },
  // Add more features as needed
];

const WhatsNew = () => {
  const [previewImage, setPreviewImage] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [activeKey, setActiveKey] = useState([]);

    const whats_new_items =  [
    {
      key: '1',
      label: 'Whats New 🔥',
   
      children:<Row gutter={[16, 16]} justify="center">
        {whatsNewFeatures.map((feature, idx) => (
          <Col
            key={idx}
            xs={24}
            sm={24}
            md={12}
            lg={8}
            xl={6}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              hoverable = {false}
              style={{
                width: "100%",
                maxWidth: 320,
                minHeight: 380,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",

              }}
              cover={
                feature.image && (
                  <img
                    alt={feature.title}
                    src={feature.image}
                    style={{
                      objectFit: "cover",
                      height: "auto",
                      maxHeight: 180,
                      width: "100%",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      setPreviewImage(feature.image);
                      setPreviewOpen(true);
                    }}
                  />
                )
              }
            >
              <Card.Meta
                title={
                  <p>
                    {feature.title}{" "}
                    {feature.tag && (
                      <Tag color={feature.tag.color} style={{ marginLeft: 8 }}>
                        {feature.tag.text}
                      </Tag>
                    )}
                  </p>
                }
                description={<div style={{ marginBottom: 16 }}>{feature.description}</div>}
              />
              {feature.buttonLink && (
                <Button
                  color="default"
                  variant="solid"
                  block
                  style={{ marginTop: 16 }}
                  href={feature.buttonLink}
                >
                  {feature.buttonText}
                </Button>
              )}
            </Card>
          </Col>
        ))}
      </Row>
    }
]

  useEffect(() => {
    const seenDate = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (seenDate === release_date) {
      setActiveKey([]); // collapsed by default
    } else {
      setActiveKey(['1']); // expanded by default
    //   localStorage.setItem(LOCAL_STORAGE_KEY, release_date);

    }
  }, []);

  const handleCollapseChange = (keys) => {
    setActiveKey(keys);
    if (keys.includes('1')) {
      localStorage.setItem(LOCAL_STORAGE_KEY, release_date);
    }
  };

    return(
        <>
        <Modal
        open={previewOpen}
        footer={null}
        onCancel={() => setPreviewOpen(false)}
        centered
        width="90vw"
        bodyStyle={{ padding: 0, background: "#000", textAlign: "center" }}
      >
        <img
          alt="Preview"
          src={previewImage}
          style={{ maxWidth: "100%", maxHeight: "80vh", margin: "auto", display: "block" }}
        />
      </Modal>
    <Collapse style={{marginTop:"20px"}} items={whats_new_items} activeKey={activeKey} 
            onChange={handleCollapseChange}

    />

      </>
    ) 
}
export default WhatsNew;